module.exports = __webpack_public_path__ + "static/media/SSD.26b4ca37.png";